import { render, staticRenderFns } from "./skeleton-square.vue?vue&type=template&id=0daff141&"
import script from "./skeleton-square.vue?vue&type=script&lang=js&"
export * from "./skeleton-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports